import { ref as c, watch as C, nextTick as j, onMounted as R, openBlock as v, createElementBlock as p, normalizeClass as I, withModifiers as z, Fragment as A, renderList as P, withDirectives as U, createBlock as N, resolveDynamicComponent as W, mergeProps as _, vShow as $, createCommentVNode as y, createVNode as G, toDisplayString as H } from "vue";
import { themeProp as J } from "../../composables/useTheme.js";
import K from "../tooltip/tooltip.vue.js";
import { FORM_SUBMIT_COLOR as x, FORM_SUBMIT_STATE as s } from "./constants.js";
import Q from "./form-button/form-button.vue.js";
import X from "./form-checkbox/form-checkbox.vue.js";
import Y from "./form-field/form-field.vue.js";
import Z from "./form-select-box/form-select-box.vue.js";
import ee from "./form-textarea/form-textarea.vue.js";
import { isValidFormField as te } from "./validation.js";
/* empty css          */
const ae = /* @__PURE__ */ Object.assign({
  name: "DsForm"
}, {
  __name: "form",
  props: {
    ...J,
    /**
     * Fields to populate form with.
     * Must contain: 'name', 'label', 'type', 'required', 'visible'
     * Optionally custom validation can be passed through a `validate` function or standard 'required'
     * Other optional parameters are: 'initialValue', 'errorMessage', and 'labels', 'placeholder' and 'options' for the select component
     */
    formId: {
      type: String,
      default: () => Math.random() + ""
    },
    fields: {
      type: Array,
      required: !0,
      validator: (r) => r.every((d) => ["name", "label", "type", "required", "visible"].every((h) => h in d))
    },
    submitColor: {
      type: String,
      default: x.green,
      validator(r) {
        return [x.green, x.black].includes(r);
      }
    },
    /**
     * State of form submit
     * Possible options are: 'start', 'loading', 'success', 'fail' and 'disabled'
     * Constants are available from '../..molecules/form'
     */
    submitState: {
      type: String,
      required: !0,
      validator: (r) => [
        s.start,
        s.loading,
        s.success,
        s.fail,
        s.disabled
      ].indexOf(r) > -1
    },
    /**
     * Label to show on form submit button
     */
    submitLabel: {
      type: String,
      required: !0
    },
    /**
     * Label to show when form submission succeeds
     */
    submitSuccessLabel: {
      type: String,
      required: !0
    },
    /**
     * Label to show when form submission fails
     */
    submitFailLabel: {
      type: String,
      required: !0
    }
  },
  emits: ["submit", "change"],
  setup(r, { emit: d }) {
    const h = d, o = r, l = c({}), i = c([]), g = c([]), b = c(null), u = c([]), f = c(/* @__PURE__ */ new Set([])), S = c(o.formId);
    C(
      () => o.formId,
      async (a) => {
        S.value = null, await j(), S.value = a;
      }
    ), C(
      () => o.submitState,
      (a, t) => {
        (t === s.success || a === s.success) && (b.value = {
          label: o.submitSuccessLabel,
          className: "ds-color-green"
        }), (t === s.fail || a === s.fail) && (b.value = {
          label: o.submitFailLabel,
          className: "ds-color-red"
        });
      }
    ), R(() => {
      u.value = o.fields || [];
      const a = u.value.filter((t) => t == null ? void 0 : t.visibilityRules);
      a.length && (f.value = new Set(
        a.map((t) => t.visibilityRules.map((e) => e.subjectFieldName)).flat()
      )), l.value = u.value.reduce((t, e) => (t[e.name] = {
        value: k(e),
        required: (e == null ? void 0 : e.required) ?? !1,
        validate: (e == null ? void 0 : e.validate) ?? !1
      }, t), {}), g.value = D(u.value), u.value.forEach((t) => {
        t.initialValue && w(t, t.initialValue, !0);
      });
    });
    const O = (a) => {
      switch (!0) {
        case a === "select":
          return Z;
        case a === "checkbox":
          return X;
        case a === "textarea":
          return ee;
        default:
          return Y;
      }
    }, T = (a) => {
      var t;
      return (t = i.value) == null ? void 0 : t.includes(a);
    }, L = () => {
      g.value.forEach((a) => {
        const t = i.value.indexOf(a.name), e = te(l.value[a.name]);
        !e && t === -1 ? i.value.push(a.name) : e && t !== -1 && i.value.splice(t, 1);
      });
    }, B = () => {
      if (!(o.submitState === s.loading || o.submitState === s.disabled) && (o.submitState !== s.loading && L(), i.value.length === 0)) {
        const a = Object.keys(l.value).reduce((t, e) => (t[e] = l.value[e].value, t), {});
        h("submit", {
          formData: a,
          formFields: u.value
        });
      }
    };
    function k({ type: a, initialValue: t }) {
      return t || (a === "checkbox" ? !1 : "");
    }
    function E(a, t) {
      return u.value.map((e) => {
        var M, q;
        if (!((M = e == null ? void 0 : e.visibilityRules) == null ? void 0 : M.some((F) => F.subjectFieldName === a)))
          return e;
        const V = i.value.indexOf(e.name);
        i.value.splice(V, 1), l.value[e.name].value = k(e);
        const n = (q = e == null ? void 0 : e.visibilityRules) == null ? void 0 : q.find(
          (F) => F.subjectFieldName === a && F.subjectFieldValues.includes(t)
        );
        if (!n)
          return {
            ...e,
            visible: !1
          };
        switch (e.type) {
          case "select":
            return {
              ...e,
              placeholder: n == null ? void 0 : n.label,
              label: n == null ? void 0 : n.label,
              options: n == null ? void 0 : n.options,
              visible: !0
            };
          case "text":
          case "tel":
            return {
              ...e,
              visible: !0
            };
          default:
            return {
              ...e,
              visible: !1
            };
        }
      });
    }
    function D(a) {
      return a.filter((t) => ((t == null ? void 0 : t.required) || (t == null ? void 0 : t.validate)) && (t == null ? void 0 : t.visible));
    }
    function w(a, t, e = !1) {
      const { name: m } = a;
      f.value.size && f.value.has(m) && (u.value = E(m, t), g.value = D(u.value)), l.value[m].value = t, e || h("change", { fieldName: m, fieldValue: t, state: o.submitState });
    }
    return (a, t) => (v(), p("div", null, [
      S.value ? (v(), p("form", {
        key: r.formId,
        method: "post",
        autocomplete: "off",
        novalidate: "",
        class: I(["ds-form", { "ds-form--with-tooltip": r.fields.find((e) => e.infoMessage) }]),
        onSubmit: z(B, ["prevent"])
      }, [
        (v(!0), p(A, null, P(u.value, (e) => (v(), p("div", {
          key: e.name + "-" + r.formId,
          class: "ds-position-relative ds-display-flex ds-align-items-flex-start"
        }, [
          U((v(), N(W(O(e.type)), _({
            "has-error": T(e.name),
            value: l.value[e.name].value,
            theme: a.theme,
            ref_for: !0
          }, e, {
            onValue: (m) => w(e, m)
          }), null, 16, ["has-error", "value", "theme", "onValue"])), [
            [$, e.visible]
          ]),
          e.infoMessage && e.visible ? (v(), N(K, {
            key: 0,
            theme: a.theme,
            description: e.infoMessage,
            class: "ds-form__tooltip"
          }, null, 8, ["theme", "description"])) : y("", !0)
        ]))), 128)),
        G(Q, {
          label: r.submitLabel,
          state: r.submitState,
          color: r.submitColor
        }, null, 8, ["label", "state", "color"])
      ], 34)) : y("", !0),
      b.value ? (v(), p("p", {
        key: 1,
        class: I(["ds-text ds-font-weight-bold ds-margin-top-24", b.value.className])
      }, H(b.value.label), 3)) : y("", !0)
    ]));
  }
}), pe = ae;
export {
  pe as default
};
